@if (isLoadingAuth() || isLoadingInitialData()) {
    <sq-full-screen-loader></sq-full-screen-loader>
} @else {
    <div class="app-container">
        <sq-sidebar #sidebar1="sqSidebar" id="sidebar1" visible>
            <sq-sidebar-header>
                <sq-sidebar-brand>
                    <img src="assets/images/surequote-logo-new.svg" alt="Logo" class="img-fluid" style="height: 30px" />
                </sq-sidebar-brand>
            </sq-sidebar-header>

            <sq-sidebar-nav [navItems]="filteredNavItems()" dropdownMode="close" compact></sq-sidebar-nav>

            <sq-sidebar-footer (logout)="logout()"> </sq-sidebar-footer>
        </sq-sidebar>
        <div class="wrapper d-flex flex-column min-vh-100">
            <sq-secure-header></sq-secure-header>

            <!-- @if (appStore.isOnTrial() && appStore.trialEndDate()) {
                <div class="container-fluid px-5">
                    <sq-trial-banner [trialEndDate]="appStore.trialEndDate()!"></sq-trial-banner>
                </div>
            } -->

            <div class="body flex-grow-1">
                <div class="container-fluid px-xxl-5">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
}
